import { useState } from 'react';
import styled, { css } from 'styled-components';

import { Goal } from '@treams/treams-network';
import { Skeleton } from '@treams/treams-ui';

import GoalContent from './GoalContent';
import GoalHeader from './GoalHeader';

const StyledDevelopmentPlanGoal = styled.div<{ collapsed: boolean }>`
	margin: 10px 0;

	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
	border: 1px solid #e0e0e0;
	border-radius: 5px;
	overflow: hidden;

	${({ collapsed }) =>
		!collapsed &&
		css`
			margin-bottom: 30px;
		`}

	&:last-child {
		margin-bottom: 40px;
	}
`;

export default Skeleton(
	function Goal({ goal, onEdit }: { goal: Goal; onEdit: (goal: Goal) => void }) {
		const [isCollapsed, setIsCollapsed] = useState(true);

		return (
			<StyledDevelopmentPlanGoal collapsed={isCollapsed}>
				<GoalHeader
					onToggleCollapse={() => setIsCollapsed(!isCollapsed)}
					goal={goal}
					collapsed={isCollapsed}
					onEdit={onEdit}
				/>
				<GoalContent collapsed={isCollapsed} goal={goal} />
			</StyledDevelopmentPlanGoal>
		);
	},
	function () {
		return (
			<StyledDevelopmentPlanGoal collapsed={false}>
				<GoalHeader.Skeleton />
				<GoalContent.Skeleton />
			</StyledDevelopmentPlanGoal>
		);
	},
);
